import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { gameQuality } from '../../constants/interfaces';

@Component({
  selector: 'app-test-card',
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./card.component.scss'],
})
export class TestCardComponent implements OnInit {
  @Input() isPromoCards: boolean | undefined;
  @Input() promoCardImage: string | undefined;
  @Input() name: string | undefined;
  @Input() rarity: gameQuality | string | undefined;
  @Input() effect: string | undefined;
  @Input() element: string | undefined;
  @Input() grade: string | undefined;
  @Input() fontSize?: number;
  @Input() quanity?: number;
  @Input() sellPrice?: number;

  constructor() {}

  ngOnInit(): void {}

  playVideo(event: any, type: 'play' | 'stop'): void {
    if (type === 'play') {
      event.srcElement.play();
    } else {
      event.srcElement.currentTime = 0;
      event.srcElement.pause();
    }
  }
}
